var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellModePaymentHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.49 7.12 59.11 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4883 29.1182H38.4883H14.4883ZM14.4883 41.1182H38.4883H14.4883ZM14.4883 53.1182H23.4883H14.4883ZM8.48828 77.1182H44.4883C47.8021 77.1182 50.4883 74.432 50.4883 71.1182V23.1182C50.4883 19.8045 47.8021 17.1182 44.4883 17.1182H8.48828C5.17457 17.1182 2.48828 19.8045 2.48828 23.1182V71.1182C2.48828 74.432 5.17457 77.1182 8.48828 77.1182Z",
    stroke: "#7647EE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_356_14875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9994 20.0986C35.9994 14.6533 40.4137 10.2391 45.859 10.2391C51.3042 10.2391 55.7185 14.6533 55.7185 20.0986C55.7185 25.5439 51.3042 29.9581 45.859 29.9581C43.5673 29.9581 41.4583 29.1763 39.784 27.8648L38.1274 29.3374C40.2196 31.0902 42.916 32.1454 45.859 32.1454C52.5122 32.1454 57.9058 26.7519 57.9058 20.0986C57.9058 13.4453 52.5122 8.05176 45.859 8.05176C39.2057 8.05176 33.8121 13.4453 33.8121 20.0986C33.8121 20.5088 33.8326 20.9143 33.8727 21.314H36.0736C36.0246 20.9157 35.9994 20.5101 35.9994 20.0986ZM47.0206 13.7189C47.0206 13.1149 46.531 12.6252 45.9269 12.6252C45.3229 12.6252 44.8333 13.1149 44.8333 13.7189V20.4836C44.8333 21.0876 45.3229 21.5773 45.9269 21.5773H53.3189C53.9229 21.5773 54.4125 21.0876 54.4125 20.4836C54.4125 19.8796 53.9229 19.39 53.3189 19.39H47.0206V13.7189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.6151,
    cy: 20.0988,
    r: 12.3012,
    fill: "#FFDDD2",
    stroke: "#FD561F",
    strokeWidth: 1.35884
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1731 11.3301C46.1731 14.514 46.1731 19.4831 46.1731 19.4831C49.375 20.8145 53.367 22.4831 53.367 22.4831",
    stroke: "#FD561F",
    strokeWidth: 2.03826,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4716 18.9092H28.4883L33.98 25.011L39.4716 18.9092Z",
    fill: "#FFDDD2",
    stroke: "#FD561F",
    strokeWidth: 1.35884
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_356_14875",
    x: 4.87277,
    y: -9.45184,
    width: 65.7729,
    height: 59.1009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.52
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.285
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_14875"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_14875",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellModePaymentHistory);
export default __webpack_public_path__ + "static/media/sell-mode-payment-history.5f2780bcd70c6895ebc1989202e94a1d.svg";
export { ForwardRef as ReactComponent };